module.exports = __webpack_public_path__ + "67cfb96d72340385b2daff0e71f6928c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/ss/ss22.jpg
// module id = 728
// module chunks = 0